import {RETRIEVE_MAP_REQUEST, SET_MAP_REQUEST} from '../actions/mapDownload';

const initialState = {
    mapRequestId: null,
    previewUrl: null,
    downloadPngUrl: null,
    downloadPdfUrl: null,
    downloadTifUrl: null,
    isLoading: true
};

export const mapDownloadReducer = (state = initialState, action) => {
    const payload = action.payload;

    switch (action.type) {
        case RETRIEVE_MAP_REQUEST:
            return {...initialState, mapRequestId: payload}
        case SET_MAP_REQUEST:
            return {...initialState, mapRequestId: state.mapRequestId, ...payload, isLoading: false}
        default:
            return state;
    }
};
